<template>
  <div
    class="wrap"
    v-if="file && file.length">
    <div 
      v-for="(item, index) in file"
      :key="index">
      <a 
        :href="item.url"
        target="_blank"
        class="link-text">
        {{item.name}}
      </a>
      <a 
        class="down-file"
        @click="download(item, index)">
        <i :class="loading[index] ? 'el-icon-loading' : 'el-icon-download'" />
      </a>
    </div>
  </div>
  <span 
    v-else 
    class="no-data">
    无
  </span>
</template>

<script>
import { FileDownload } from '@/api'
import { withLoadingApi } from '@/utils/hoc'
import { copyObj } from '@/utils'
export default {
  data () {
    return {
      loading: []
    }
  },
  props: {
    file: Array
  },
  methods: {
    download({ url, name }, index){
      withLoadingApi(
        FileDownload({url}),
        this.loading,
        this,
        index
      ).then(({data}) => {
        copyObj(data, name);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap{
  display: flex;
  flex-direction: column;
  row-gap: 0.1575rem;
  > div{
    display: flex;
    justify-content: center;
    column-gap: 0.245rem;
    a{
      line-height: initial;
    }
    a:last-child{
      font-size: 1.295rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TableCell/FileCell.vue